@let control = ngControl?.control;

@if (control && isReady) {
  @let displayError = control.errors && showErrorState();
  @let stateClass = displayError ? 'is-error' : 'is-primary';

  <intl-tel-input
    #telInput
    [initOptions]="initOptions"
    [inputProps]="{
      class: inputClassBase() + ' ' + stateClass,
      name: ngControl.name
    }"
    (numberChange)="handleNumberChange($event)"
    (validityChange)="setValidity($event, 'template')"
    (countryChange)="handleCountryChange()"
    (blur)="onBlur($event)"
    (focus)="onFocus($event)" />

  @if (displayError && !hideErrorMessage()) {
    @if (control.hasError('invalidPhone')) {
      <p class="error-message">{{ 'NOTIFICATION-PREFERENCES.ERROR-ENTER-VALID-PHONE' | translate }}</p>
    } @else if (control.hasError('required')) {
      <p class="error-message">{{ 'MANAGEMENT.DATASETS.REQUIRED' | translate }}</p>
    }
  }
}
